var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from "@mui/material/Typography";
import { Box, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocalize } from "../utils/text.util";
export var getFolioItemGridColumns = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.showDiscount, showDiscount = _c === void 0 ? true : _c, _d = _b.showTax, showTax = _d === void 0 ? true : _d;
    return [
        'minmax(0, 1fr)',
        '70px',
        '40px',
        showDiscount ? '64px' : undefined,
        '110px',
        showTax ? '64px' : undefined,
        '88px',
    ].filter(Boolean).join(' ');
};
export var folioItemCells = {
    price: { textAlign: 'right' },
    quantity: { textAlign: 'right' },
    discount: { textAlign: 'right' },
    category: { minWidth: 0, textAlign: 'right' },
    taxRate: { minWidth: 0, textAlign: 'right' },
    total: { textAlign: 'right' },
};
export var getFolioItemDescription = function (item) { return ([item.description || item.priceDescription, item.serviceInventoryCode].filter(Boolean).join(' - ') || '-'); };
export var hasFolioItemDiscount = function (item) { return ((item.discounts || []).some(function (discount) { return discount.amountCentsOff !== undefined || discount.percentOff !== undefined; })); };
export var hasFolioItemTax = function (item) {
    var _a, _b;
    return (!!item.taxRateId || !!((_a = item.taxRateSnap) === null || _a === void 0 ? void 0 : _a.name) || ((_b = item.taxRateSnap) === null || _b === void 0 ? void 0 : _b.rate) !== undefined);
};
export var FolioItemsHeader = function (_a) {
    var _b = _a.showDiscount, showDiscount = _b === void 0 ? true : _b, _c = _a.showTax, showTax = _c === void 0 ? true : _c;
    var t = useTranslation().t;
    var caption = function (label, sx) { return (_jsx(Typography, __assign({ variant: 'body1', color: 'text.secondary', sx: sx, noWrap: true }, { children: label }))); };
    return (_jsxs(Box, __assign({ alignItems: 'center', sx: {
            display: 'grid',
            gridTemplateColumns: getFolioItemGridColumns({ showDiscount: showDiscount, showTax: showTax }),
            columnGap: 1.5,
            width: '100%',
            pb: 1,
            borderBottom: '1px solid',
            borderColor: 'divider',
        } }, { children: [caption(t('Description'), { flex: 1 }), caption(t('Price'), folioItemCells.price), caption(t('Qty'), folioItemCells.quantity), showDiscount && caption(t('Discount'), folioItemCells.discount), caption(t('Category'), folioItemCells.category), showTax && caption(t('Tax'), folioItemCells.taxRate), caption(t('Total'), folioItemCells.total)] })));
};
var FolioItemRow = function (_a) {
    var _b;
    var item = _a.item, _c = _a.showDivider, showDivider = _c === void 0 ? true : _c, _d = _a.showDiscount, showDiscount = _d === void 0 ? true : _d, _e = _a.showTax, showTax = _e === void 0 ? true : _e;
    var t = useTranslation().t;
    var tFallback = useLocalize().tFallback;
    var formatAmount = function (amount) {
        if (amount === void 0) { amount = item.price; }
        return ((amount === null || amount === void 0 ? void 0 : amount.amount) !== undefined
            ? "".concat(amount.amount.toFixed(2), " ").concat(amount.currency || '-')
            : '-');
    };
    var formatDiscounts = function (discounts) {
        if (!discounts || discounts.length === 0)
            return '-';
        return discounts.map(function (d) {
            if (d.amountCentsOff !== undefined) {
                return "-".concat((d.amountCentsOff / 100).toFixed(2));
            }
            else if (d.percentOff !== undefined) {
                return "-".concat(d.percentOff, "%");
            }
            else {
                return '-';
            }
        }).join(', ');
    };
    var description = getFolioItemDescription(item);
    var descriptionDisplay = "".concat(item.inclusive ? '* ' : '').concat(description).concat(item.inclusive ? " (".concat(t('Inclusive'), ")") : '');
    var taxRate = ((_b = item.taxRateSnap) === null || _b === void 0 ? void 0 : _b.name) || '-';
    var category = item.itemCategory ? tFallback("Folio item category ".concat(item.itemCategory), item.itemCategory) : '-';
    return (_jsxs(Box, __assign({ alignItems: 'center', sx: {
            display: 'grid',
            gridTemplateColumns: getFolioItemGridColumns({ showDiscount: showDiscount, showTax: showTax }),
            columnGap: 1.5,
            width: '100%',
            py: 1,
            borderBottom: showDivider ? '1px solid' : 'none',
            borderColor: 'rgba(0, 0, 0, 0.08)',
        } }, { children: [_jsx(Stack, __assign({ direction: 'row', alignItems: 'center', gap: 0.5, sx: { flex: 1, minWidth: 0 } }, { children: _jsx(Typography, __assign({ variant: 'body2', noWrap: true }, { children: descriptionDisplay })) })), _jsx(Typography, __assign({ variant: 'body2', sx: folioItemCells.price }, { children: formatAmount(item.price) })), _jsx(Typography, __assign({ variant: 'body2', sx: folioItemCells.quantity }, { children: item.quantity !== undefined ? item.quantity : '-' })), showDiscount && (_jsx(Typography, __assign({ variant: 'body2', sx: folioItemCells.discount }, { children: formatDiscounts(item.discounts || []) }))), _jsx(Typography, __assign({ variant: 'body2', sx: folioItemCells.category, noWrap: true }, { children: category })), showTax && (_jsx(Typography, __assign({ variant: 'body2', sx: folioItemCells.taxRate, noWrap: true }, { children: taxRate }))), _jsx(Typography, __assign({ variant: 'body2', sx: folioItemCells.total }, { children: formatAmount(item.totalAmount) }))] }), item.id));
};
export default FolioItemRow;
